import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme } from 'styles/theme';

export const Wrapper = styled.nav`
  display: flex;

  .rank {
    margin-top: -16px;
    margin-right: 16px; 

    @media (${breakpoint.lgMin}) {
      margin-top: -32px;
      margin-right: 48px;
    }
  }
`;

export const LinksWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  height: 48px;
  padding-bottom: 8px;
  padding-top: 8px;

  @media (${breakpoint.lgMin}) {
    height: 64px;
  }

  .previous-link:only-of-type { 
    margin-right: auto;
  }

  .next-link:only-of-type {
    margin-left: auto;
  }
`;
